import { Environment } from './environment.interface';

export const environment: Environment = {
    production: true,
    apiBaseUrl: '#{apiBaseUrl}',
    apiBasePdf: '#{apiBasePdf}',
    apiBaseStore: '#{apiBaseStore}',
    firebase: {
        apiKey: 'AIzaSyDWUa07Vljf6_QwUZA2bi4-UKAeJlSxNuY',
        authDomain: 'wanview-store.firebaseapp.com',
        projectId: 'wanview-store',
        storageBucket: 'wanview-store.appspot.com',
        messagingSenderId: '1047775373251',
        appId: '1:1047775373251:web:215f9ddbd8cc6a03ef7f76',
        measurementId: 'G-X0CY2J5Q9Q',
    },
    stripePublicKey: '#{stripeKey}',
};
